const messageKeys = [
  'CARD_DECLINED',
  'KONG_PURCHASE_COMPLETE',
  'PAYMENT_ERROR',
  'PAYMENT_REQUIRES_ACTION',
  'PAYMENT_SUCCEEDED',
  'STEAM_PURCHASE_COMPLETE',
  'YANDEX_PURCHASE_COMPLETE',
];

const messages: Record<PaymentsStoreMessage, PaymentsStoreMessage> = Object.fromEntries(
  messageKeys.map((k) => [k, k])
) as Record<PaymentsStoreMessage, PaymentsStoreMessage>;
export default messages;

export type PaymentsStoreMessage = (typeof messageKeys)[number];
